module.exports = require("angular-translate-interpolation-messageformat");